import { configureStore, createSlice } from "@reduxjs/toolkit";

export interface GridDataState {
    gridData: any;
}

const initialState: GridDataState = {
    gridData: null,
};

const gridDataSlice = createSlice({
    name: 'gridData',
    initialState,
    reducers: {
        setGridData(state, action) {
            state.gridData = action.payload;
        },
        clearGridData(state) {
            state.gridData = null;
        },
    }
});

export const Store = configureStore({
    reducer: {
        gridData: gridDataSlice.reducer
    }
});

export const { setGridData, clearGridData } = gridDataSlice.actions;